import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-reqq-lite';
import CustomRouter from 'partial/wrappers/CustomRouter';
import store from 'setup/store';
import history from 'setup/history';
import App from './App';
import 'react-datepicker/dist/react-datepicker.css';
import 'assets/css/styles.css';
import 'assets/css/theme.css';

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <CustomRouter history={history}>
        <App />
      </CustomRouter>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root'),
);
